/**
 * Display-only cleanup for InfoCar model and version names.
 * The catalog stores a broken é (Unicode replacement char �) in Coupé / Cpé.
 * Show é instead of hiding it. Does not strip slashes in "2p/b/2993cc".
 */

const MOJIBAKE_PAIRS = [
  ["Ã©", "é"],
  ["Ã¨", "è"],
  ["Ã ", "à "],
  ["Ã¡", "á"],
  ["Ã¢", "â"],
  ["Ã¤", "ä"],
  ["Ã¹", "ù"],
  ["Ãº", "ú"],
  ["Ã¼", "ü"],
  ["Ã²", "ò"],
  ["Ã³", "ó"],
  ["Ã¶", "ö"],
  ["Ã¬", "ì"],
  ["Ã­", "í"],
  ["Ã±", "ñ"],
  ["ÃŸ", "ß"],
  ["Â°", "°"],
  ["Â", ""],
  ["â€™", "'"],
  ["â€˜", "'"],
  ["â€œ", '"'],
  ["â€�", '"'],
  ["â€“", "–"],
  ["â€”", "—"],
];

export function sanitizeVehicleText(value) {
  if (typeof value !== "string" || !value) return value;

  let text = value;
  for (let i = 0; i < MOJIBAKE_PAIRS.length; i += 1) {
    const [from, to] = MOJIBAKE_PAIRS[i];
    if (text.includes(from)) text = text.split(from).join(to);
  }

  return text
    .replace(/\uFFFD/g, "é")
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F\u200B-\u200D\uFEFF]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function sanitizeModelOrVersion(item) {
  if (!item || typeof item !== "object") return item;
  if (typeof item.description === "string") {
    item.description = sanitizeVehicleText(item.description);
  }
  if (typeof item.fullDescription === "string") {
    item.fullDescription = sanitizeVehicleText(item.fullDescription);
  }
  return item;
}

/** Only `/info-car/models` and `/info-car/versions` list payloads. */
export function sanitizeModelsVersionsResponse(routeString, data) {
  if (!data || typeof data !== "object") return data;
  if (routeString === "/info-car/models" && Array.isArray(data.models)) {
    data.models.forEach(sanitizeModelOrVersion);
  }
  if (routeString === "/info-car/versions" && Array.isArray(data.versions)) {
    data.versions.forEach(sanitizeModelOrVersion);
  }
  return data;
}

/** Vuetify combobox custom-filter for model/version dropdowns. */
export function vehicleTextFilter(itemTitle, queryText) {
  if (!queryText) return true;
  const hay = sanitizeVehicleText(String(itemTitle || "")).toLowerCase();
  const needle = sanitizeVehicleText(String(queryText)).toLowerCase();
  return hay.includes(needle);
}
